import { useState, useEffect } from 'react'
import { getEjipMeberEMPAPI } from '../services/ejip'

function UseEmpsNameEjip(orgId = 0, searchs, fundId) {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const resp = await getEjipMeberEMPAPI({
        orgId,
        searchs,
        page: 1,
        size: 20,
        fundId
      })
      if (!resp) return

      if (resp.status) {
        const newData = resp.result.map((d, i) => {
          if (/^[a-zA-Z]+$/.test(searchs)) {
            return {
              value: d.code,
              label: `${d.code} ${d.name_en} ${d.surname_en}`,
              username: d.username,
              fullname: `${d.name_en} ${d.surname_en}`,
              orgId: orgId,
              code: d.code
            }
          } else {
            return {
              value: d.code,
              label: `${d.code} ${d.name_th} ${d.surname_th}`,
              username: d.username,
              fullname: `${d.name_th} ${d.surname_th}`,
              orgId: orgId,
              code: d.code
            }
          }
        })

        setData(newData)
      } else {
        setData([])
      }
    }

    if (orgId && fundId) {
      getData()
    }
  }, [orgId, searchs, fundId])

  return data
}

export default UseEmpsNameEjip
